

export function urlBase64ToUint8Array(base64: string) {
    const padding = "=".repeat((4 - (base64.length % 4)) % 4);
    const base64Safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64Safe);
    const output = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
    return output;
}

function isStandalonePWA() {
    return (
        (window.matchMedia?.("(display-mode: standalone)").matches ?? false) ||
        ((navigator as any).standalone === true) ||
        document.referrer.startsWith("android-app://")
    );
}

export async function ensurePushSubscribed(apiUrl: string, userId: string) {
    try {

        // alert("ensurePushSubscribed START\n" + apiUrl);

        // 1) فقط روی کلاینت + HTTPS/localhost
        if (typeof window === "undefined") {
            //alert("No window SSR");
            return null;
        }
        const secure = window.location.protocol === "https:" || window.location.hostname === "localhost";
        if (!secure) {
            //alert("Not secure origin"); 
            return null;
        }

        // 2) چک پشتیبانی پایه
        if (!("serviceWorker" in navigator)) {
            //alert("No serviceWorker"); 
            return null;
        }
        if (!("PushManager" in window)) {
            //alert("No PushManager"); 
            return null;
        }

        // 3) iOS: فقط وقتی PWA نصب‌شده است
        //const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
        if (!isStandalonePWA()) {
            //alert("iOS Safari: Push only works in installed PWA");
            return null;
        }

        // 4) اجازه نوتیف باید قبلاً گرفته شده باشد
        if (!("Notification" in window)) {
            //alert("No Notification API"); 
            return null;
        }
        if (Notification.permission !== "granted") {
            //alert("Notification permission is not granted");
            return null;
        }

        // 5) SW آماده شود (و یک update هم بزنیم)
        const reg = await navigator.serviceWorker.ready;
        reg.update?.();

        // 6) اگر قبلاً subscribed بود، همونو به سرور بفرست (آپدیت userId) و برگرد
        let sub = await reg.pushManager.getSubscription();
        if (sub) {
            //alert("Already subscribed → sending to server");
            await fetch(`${apiUrl}/base/push/subscribe/?userId=${encodeURIComponent(userId)}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(sub),
                credentials: "include",
            });
            //window.alert(`Server responded: ${r.status} ${r.ok ? "OK" : "FAIL"}`);
            return sub;
        }

        // 7) Subscribe جدید
        const pub = "BAsg4u0OGZwScT4Z286rfLA9vvZrGhb_SoKTORTK6myLBMknJ2TO0B5tOMFo1mvpWFbyd318_nzcrGv_pfG_C68";
        if (!pub) throw new Error("Missing VAPID public key");

        // window.alert("Subscribing…");
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(pub),
        });

        // 8) ارسال به سرور
        // alert("Sending subscription to server…" + userId);
        await fetch(`${apiUrl}/base/push/subscribe/?userId=${encodeURIComponent(userId)}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(sub),
            credentials: "include",
        });
        //alert(`Server responded: ${res.status} ${res.ok ? "OK" : "FAIL"}`);
        return sub;

    } catch (err: any) {
        //window.alert("ensurePushSubscribed ERROR:\n" + (err?.message ?? String(err)));
        return null;
    }
}